/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import { GET_FEEDS, SET_FEEDS } from "../actions/feeds";

// api
import { getThreadsApi } from "../../api/posts";
import {AUTH_LOGOUT} from "../actions/auth";
import router from "../../router";
const state = {
  feeds: []
};

const getters = {
  feedsList: state => state.feeds
};

const actions = {
  [GET_FEEDS]: ({ commit }) => {
    return getThreadsApi().then(resp => {
      commit(SET_FEEDS, resp.data);
      return Promise.resolve(resp.data);
    }).catch(() => {
      commit(AUTH_LOGOUT);
      router.push("/login");
    });
  }
};

const mutations = {
  [SET_FEEDS]: (state, payload) => {
    state.feeds = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
